import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Modal,
  Grid,
  Stack,
  Pagination,
  Checkbox,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useRef, useState } from "react";

import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";

import { useSelector } from "react-redux";

import DatePicker from "react-datepicker";
import EventIcon from "@mui/icons-material/Event";
import SearchIcon from "@mui/icons-material/Search";
import { getAlldetailSerice } from "../services/servicesListApi";
import Swal from "sweetalert2";
import { ModalHeader } from "../../common/modalHeader";
import { getItems } from "../items_services/itemApi";
export default function AppoinmentModal({ open, setOpen, data, setData }) {
  //  const arr=[]
  const [arr, setArr] = useState(["Hair cutting", "Shaving"]);
  const infoD = useSelector((state) => state.reducer.userDetail);

  const url = infoD?.profileId;

  const params = new URLSearchParams(new URL(url).search);
  const billerId = params.get("billerId");

  useEffect(() => {
    console.log("datadata ==", data);
  }, [data]);
  useEffect(() => {
    getAlldetailSerice({ billerId: Number(billerId) }, (res) => {
      console.log("");
      setArr(res?.data);
    });
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          background: "white",
          width: { xs: "95%", sm: "50%", md: "40%", lg: "40%", xl: "40%" },

          position: "absolute",
          left: {sm:"30%", xs:"5%"},
          top: "10%",
          borderRadius: "10px",
          maxHeight: "80vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            position: "sticky",
            top: 0,
            background: "white",
            zIndex: 10,
            borderRadius: "10px",
            borderBottom: "1px solid #ddd",
          }}
        >
          <ModalHeader
            title={"Services"}
            onClose={(data) => {
              setOpen(data);
            }}
          />
        </Box>

        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            padding: "10px",
          }}
        >
          <Grid container spacing={1}>
            {arr?.map((ele, index) => (
              <Grid item xs={12} key={index}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography>{ele?.itemDescription}</Typography>
                  <Checkbox
                    checked={
                      data.findIndex(
                        (ele2) => ele2.service === ele?.itemDescription
                      ) !== -1
                    }
                    onChange={() => {
                      let tempArr = [...data];
                      let indexV = data.findIndex(
                        (ele2) => ele2.service === ele?.itemDescription
                      );
                      if (indexV === -1) {
                        setData([
                          ...data,
                          { isChecked: false, service: ele?.itemDescription },
                        ]);
                      } else {
                        tempArr.splice(indexV, 1);
                        setData(tempArr);
                      }
                    }}
                  />
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>

        <Box
          sx={{
            position: "sticky",
            bottom: 0,
            background: "white",
            padding: "10px",
            borderTop: "1px solid #ddd",
            borderRadius: "0 0 10px 10px",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={() => {
              setOpen(false);
            }}
          >
            Done
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
